import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import {
  type EmarSecondSignatureSettings,
  SecondSignaturePolicy
} from './types'

export const EMAR_SECOND_SIGNATURE_QUERY_KEY = [
  'emar-settings',
  'second-signature'
]

const useEmarSecondSignatureSettings = ({
  enabled = true
}: {
  enabled?: boolean
} = {}) => {
  const { data, isLoading, isError, refetch } =
    useQuery<EmarSecondSignatureSettings>(
      EMAR_SECOND_SIGNATURE_QUERY_KEY,
      () => getJSON({ url: '/emar-settings/second-signature' }),
      { enabled }
    )

  return {
    requirement: data?.requirement ?? SecondSignaturePolicy.Optional,
    isLoading,
    isError,
    refetch
  }
}

export default useEmarSecondSignatureSettings
